'use client';

import { useEffect, useState } from 'react';
import { CsrEvent } from 'services/csr-audit-summary/types';

import CsrActionSummaryModal from './csr-action-summary-modal';

type CsrActionSummaryContainerProps = {
  csrAuditSummaryResponse: {
    csrEvents: CsrEvent[];
  };
};

function CsrActionSummaryContainer(
  props: Readonly<CsrActionSummaryContainerProps>
) {
  const { csrAuditSummaryResponse } = props;
  const [csrEvents, setCsrEvents] = useState<CsrEvent[] | null>();
  const [modalVisible, setModalVisible] = useState(false);

  const handleClose = () => {
    setModalVisible(false);
  };

  useEffect(() => {
    if (csrAuditSummaryResponse?.csrEvents?.length) {
      setCsrEvents(csrAuditSummaryResponse.csrEvents);
      setModalVisible(true);
    }
  }, [csrAuditSummaryResponse]);

  if (!modalVisible) return null;

  return (
    <CsrActionSummaryModal
      csrEvents={csrEvents}
      handleClose={handleClose}
      modalVisible={modalVisible}
    />
  );
}

export default CsrActionSummaryContainer;
